import ModalMessageDebtor from "@/components/billing/debtors/ModalMessageDebtor.vue";
import AddComment from "@/components/billing/debtors/comment/addComment/AddComment.vue";
import ShowHistoryAccounts from "@/components/billing/debtors/comment/showHistoryAccounts/ShowHistoryAccounts.vue";
import AdvancedSelect from "@/components/common/advanced-select/AdvancedSelect.vue";
import TableField from "@/components/common/table-field/TableField.vue";

export default {
    name: 'Debtors',

    components: {
        TableField,
        ModalMessageDebtor,
        AddComment,
        AdvancedSelect,
        ShowHistoryAccounts
    },

    data() {
        return {
            loading: false,
            debtors: [],
            controller: null,
            blockedInfo: null,
            params: {
                page: 1,
                pageSize: this.getPageSize(),
                total: 0,
                search: this.getSearch(),
                filter: {
                    isBlockedClient: '',
                    isClientEnabled: ''
                }
            }
        }
    },

    computed: {
        columns() {
            return [
                { title: this.$t('debtors.name'), key: "name" },
                { title: this.$t('debtors.regNumber'), key: "regNumber" },
                { title: this.$t('debtors.lastPaymentDate'), key: "lastPaymentDate" },
                { title: this.$t('debtors.lastBillDate'), key: "lastBillDate" },
                { title: this.$t('debtors.lastBillPeriod'), key: "lastBillPeriod" },
                { title: this.$t('debtors.averageBill'), key: "billPriceAvg" },
                { title: this.$t('debtors.billsPrice'), key: "billPriceTotal" },
                { title: this.$t('debtors.paymentsPrice'), key: "paymentsPriceTotal" },
                { title: this.$t('debtors.revenue'), key: "revenuePriceTotal" },
                { title: this.$t('debtors.balance'), key: "balance" },
                { title: this.$t('debtors.malice'), key: "balanceRatio" },
                {
                    key: "actions",
                    minWidth: "200px",
                    actions: [
                        {
                            emit: "sendMessage",
                            label: (row) => row.blokedTrackpro == '1' ? this.$t('debtors.btn-blocked') : this.$t('debtors.btn-active'),
                            class: (row) => row.blokedTrackpro == '1' ? "btn-sm btn-warning" : "btn-sm btn-success",
                            tooltip: (row) => row.blokedTrackpro == '1' ? "Blocked" : "Active"
                        },
                        { emit: "addComment", icon: "bi bi-plus-circle", class: "btn-sm btn-primary", tooltip: "Add comment" },
                        { emit: "showHistoryAccounts", icon: "bi bi-info-circle", class: "btn-sm btn-info", tooltip: "Show history accounts" }
                    ]
                }
            ]
        },

        companyId () {
            return this.$store.state.companyId;
        }
    },

    methods: {
        getPageSize() {
            const pageSize = localStorage.getItem('debtors-page-size');
            return pageSize ? Number(pageSize) : 20;
        },

        getSearch() {
            const search = localStorage.getItem('debtors_params_search');
            return search ? search : null;
        },

        async populateData() {
            this.loading = true;
            try {
                const response = await this.ApiRequest.requestAsync(
                    'billing/debtors',
                    this.ApiRequest.REQUEST_POST,
                    this.params,
                    'debtors',
                    true
                );

                if (!response || response.error || response.canceled) return;
                const { data, pagination } = response;
                this.debtors = this.BasicHelper.cloneObject(data.debtors);
                this.params = {
                    ...this.params,
                    ...pagination
                }
            } finally {
                this.loading = false;
            }
        },

        async sendMessage (el, approved = false) {
            if (approved) {
                const isBlocked = el.blokedTrackpro == 1 ? 0 : 1;
                const { data } = await this.ApiRequest.requestAsync(
                    `billing/debtors/user/status`,
                    this.ApiRequest.REQUEST_POST,
                    {
                        clientId: el.clientId,
                        blokedTrackpro: isBlocked,
                        blockedInfo: el.blockedInfo
                    },
                    'debtors-user-status',
                    false
                );

                if (data.success) {
                    const row = this.debtors.find((row) => {
                        return row.clientId == el.clientId
                    });
                    this.debtors[this.debtors.indexOf(row)].blokedTrackpro = isBlocked;
                }
            } else {
                el.blockedInfo = null;
                const message = el.blokedTrackpro ? this.$t('debtors.msg_active') : this.$t('debtors.msg_blocked');
                this.$refs.sendBlockMsgBox.show(el, message);
            }
        },

        handleAction({ type, row }) {
            if (type === 'addComment') {
                this.addComment(row.clientId, row.balance);
            } else if (type === 'showHistoryAccounts') {
                this.showHistoryAccounts(row.clientId);
            } else if (type === 'sendMessage') {
                this.sendMessage(row);
            }
        },

        addComment(clientId, amount_debt) {
            this.$refs.addModalComment.show(clientId, amount_debt);
        },

        showHistoryAccounts(clientId) {
            this.$refs.showHistoryAccounts.show(clientId);
        }
    },

    beforeMount() {
        this.populateData();
    }
}
